// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18xMI","col":"styles_col__w-uPA"};